/*
 * @Author: 谭冬阳
 * @AuthorEmail: tandongyang@1ceng.com
 * @Date: 2026-04-11 15:38:39
 * @LastEditors: 谭冬阳
 * @LastEditTime: 2026-04-13 16:00:55
 * @Description:
 */
// 全局常量
export const DEFAULT_IMAGE =
    'data:image/png;base64,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';
// 产品版本状态映射
export const PRODUCT_VERSION_STATUS_MAP: Record<
    string,
    'success' | 'processing' | 'error' | 'default' | 'warning'
> = {
    '草稿': 'default',
    '待审核': 'processing',
    '已发布': 'success',
    '归档': 'default',
    '作废': 'error',
};
// 选中的产品数据存储键名
export const SELECTED_PRODUCT_KEY = 'selectedProducts';

// 物料配置列表页面键名
export const MATERIAL_CONFIG_LIST_PAGE_KEY = 'materialConfigListPage';
// 生成带用户ID的选中产品存储键名（自动获取当前登录用户）
export const getSelectedProductKey = (): string => {
    const profile =
        typeof window !== 'undefined'
            ? (() => {
                  try {
                      return JSON.parse(
                          localStorage.getItem('profile') || 'null',
                      );
                  } catch {
                      return null;
                  }
              })()
            : null;
    return `${SELECTED_PRODUCT_KEY}_${profile?.id || 0}`;
};

//选中的采购订单数据存储键名
export const SELECTED_PURCHASE_ORDER_KEY = 'selectedPurchaseOrders';
//生成带用户ID的选中采购订单存储键名（自动获取当前登录用户）
export const getSelectedPurchaseOrderKey = (): string => {
    const profile =
        typeof window !== 'undefined'
            ? (() => {
                  try {
                      return JSON.parse(
                          localStorage.getItem('profile') || 'null',
                      );
                  } catch {
                      return null;
                  }
              })()
            : null;
    return `${SELECTED_PURCHASE_ORDER_KEY}_${profile?.id || 0}`;
};

// 状态选项
export const STATUS_OPTIONS = [
    { value: 'all', label: '全部状态' },
    { value: 'true', label: '启用' },
    { value: 'false', label: '禁用' },
];
export const createPercentRule = (
    decimalDigits: 2 | 4 = 2,
    message?: string,
) => {
    const tipMsg =
        message ?? `请输入 0~100 之间的值，最多小数点后${decimalDigits}位`;
    // 动态拼接小数位正则 \d{1,2} 或 \d{1,4}
    const decimalPart = `(\\.\\d{1,${decimalDigits}})?`;
    // 完整正则：0-99整数 + 可选小数 或 100(.00...)
    const regStr = `^(\\d{1,2}${decimalPart}|100(\\.0{1,${decimalDigits}})?)$`;
    const pattern = new RegExp(regStr);

    return {
        pattern,
        message: tipMsg,
    };
};

//税率选项
export const TAX_RATE_OPTIONS = [
    { value: '0.1300', label: '13%' },
    { value: '0.0900', label: '9%' },
    { value: '0.0600', label: '6%' },
    { value: '0.0500', label: '5%' },
    { value: '0.0300', label: '3%' },
    { value: '0.0100', label: '1%' },
    { value: '0.0000', label: '0%' },
];

//采购单状态映射
export const PURCHASE_ORDER_STATUS_MAP: Record<
    string,
    'draft' | 'generated' | 'placed' | 'completed' | 'closed'
> = {
    '草稿': 'draft',
    '已生成': 'generated',
    '已下单': 'placed',
    '已完成': 'completed',
    '已关闭': 'closed',
};
